const config = {
  openGraph: {
    type: 'website',
    siteName: 'Kijiji',
  },
  additionalMetaTags: [{ property: 'og:country-name', content: 'Canada' }],
}

export default config
